module.exports = __webpack_public_path__ + "img/experience.79195149.svg";